var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Generar Informe" },
        on: {
          cerrar: function($event) {
            return _vm.handleCerrar()
          }
        }
      }),
      _c(
        "div",
        { staticClass: "modal cardnew" },
        [
          _c(
            "div",
            { attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "col-md-12",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.isFormValid,
                        callback: function($$v) {
                          _vm.isFormValid = $$v
                        },
                        expression: "isFormValid"
                      }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-card",
                        { staticClass: "rounded-card" },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "FormFieldsContainer",
                                { attrs: { titulo: "Información General" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "", md3: "", lg3: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: !_vm.disabled && "required",
                                            expression:
                                              "!disabled && 'required'"
                                          }
                                        ],
                                        attrs: {
                                          items: _vm.tiposInforme,
                                          label: "Tipo de Informe",
                                          icon: "fas fa-angle-down",
                                          "item-text": "descripcion",
                                          "item-value": "id",
                                          "error-messages": _vm.errors.collect(
                                            "informeRequerido"
                                          ),
                                          "data-vv-name": "informeRequerido",
                                          required: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.setTipoInforme()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.informeSeleccionado
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields
                                                .informeSeleccionado,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.informeSeleccionado.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm.isEstadoTransmision
                                    ? _c(
                                        "v-flex",
                                        {
                                          attrs: { xs3: "", md3: "", lg3: "" }
                                        },
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              label:
                                                _vm.formFields.program.label,
                                              id: _vm.formFields.program.id,
                                              color: "green",
                                              hint: _vm.hint,
                                              "persistent-hint": true
                                            },
                                            on: { change: _vm.switchProgram },
                                            model: {
                                              value: _vm.program,
                                              callback: function($$v) {
                                                _vm.program = $$v
                                              },
                                              expression: "program"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.isEstadoTransmision && _vm.program
                                    ? _c(
                                        "v-flex",
                                        {
                                          attrs: { xs3: "", md3: "", lg3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|emailValidate",
                                                expression:
                                                  "`required|emailValidate`"
                                              }
                                            ],
                                            attrs: {
                                              hint:
                                                "Puede ingresar varios correos separados por punto y coma (;)",
                                              label:
                                                _vm.formFields.emails.label,
                                              "data-vv-name": "emailValidate",
                                              id: _vm.formFields.emails.id,
                                              "error-messages": _vm.errors.collect(
                                                "emailValidate"
                                              )
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.emails.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.emails,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.emails.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.isUltimaActividad &&
                                  !_vm.mostrarAcumulado &&
                                  !_vm.isEstadoTransmision
                                    ? _c(
                                        "v-flex",
                                        { attrs: { md2: "" } },
                                        [
                                          _c("DatePicker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  !_vm.isUltimaActividad &&
                                                  !_vm.mostrarAcumulado
                                                    ? "required"
                                                    : "",
                                                expression:
                                                  "\n                      !isUltimaActividad && !mostrarAcumulado\n                        ? 'required'\n                        : ''\n                    "
                                              }
                                            ],
                                            attrs: {
                                              label: "Desde",
                                              "error-messages": _vm.errors.collect(
                                                _vm.formFields.fechaDesde.id
                                              ),
                                              id: _vm.formFields.fechaDesde.id,
                                              min: _vm.fechaMinima,
                                              max: _vm.fechaMaxima
                                            },
                                            model: {
                                              value:
                                                _vm.formFields.fechaDesde.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formFields.fechaDesde,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formFields.fechaDesde.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !_vm.isUltimaActividad &&
                                            !_vm.mostrarAcumulado &&
                                            !_vm.isEstadoTransmision,
                                          expression:
                                            "\n                    !isUltimaActividad &&\n                      !mostrarAcumulado &&\n                      !isEstadoTransmision\n                  "
                                        }
                                      ],
                                      attrs: { md2: "" }
                                    },
                                    [
                                      _c("TimePicker", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value:
                                              !_vm.isUltimaActividad &&
                                              !_vm.mostrarAcumulado
                                                ? "required"
                                                : "",
                                            expression:
                                              "\n                      !isUltimaActividad && !mostrarAcumulado\n                        ? 'required'\n                        : ''\n                    "
                                          }
                                        ],
                                        attrs: {
                                          label:
                                            _vm.formFields.horaInicio.label,
                                          "error-messages": _vm.errors.collect(
                                            _vm.formFields.horaInicio.id
                                          ),
                                          id: _vm.formFields.horaInicio.id,
                                          disabled: _vm.disabled
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.horaInicio.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.horaInicio,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.horaInicio.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !_vm.isUltimaActividad &&
                                            !_vm.mostrarAcumulado &&
                                            !_vm.isEstadoTransmision,
                                          expression:
                                            "\n                    !isUltimaActividad &&\n                      !mostrarAcumulado &&\n                      !isEstadoTransmision\n                  "
                                        }
                                      ],
                                      attrs: { md2: "" }
                                    },
                                    [
                                      _c("DatePicker", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value:
                                              !_vm.isUltimaActividad &&
                                              !_vm.mostrarAcumulado
                                                ? "required"
                                                : "",
                                            expression:
                                              "\n                      !isUltimaActividad && !mostrarAcumulado\n                        ? 'required'\n                        : ''\n                    "
                                          }
                                        ],
                                        attrs: {
                                          label: "Hasta",
                                          "error-messages": _vm.errors.collect(
                                            _vm.formFields.fechaHasta.id
                                          ),
                                          id: _vm.formFields.fechaHasta.id,
                                          min: _vm.fechaMinima,
                                          max: _vm.fechaMaxima
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.fechaHasta.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.fechaHasta,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.fechaHasta.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !_vm.isUltimaActividad &&
                                            !_vm.mostrarAcumulado &&
                                            !_vm.isEstadoTransmision,
                                          expression:
                                            "\n                    !isUltimaActividad &&\n                      !mostrarAcumulado &&\n                      !isEstadoTransmision\n                  "
                                        }
                                      ],
                                      attrs: { md2: "" }
                                    },
                                    [
                                      _c("TimePicker", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value:
                                              !_vm.isUltimaActividad &&
                                              !_vm.mostrarAcumulado
                                                ? "required"
                                                : "",
                                            expression:
                                              "\n                      !isUltimaActividad && !mostrarAcumulado\n                        ? 'required'\n                        : ''\n                    "
                                          }
                                        ],
                                        attrs: {
                                          label: _vm.formFields.horaHasta.label,
                                          "error-messages": _vm.errors.collect(
                                            _vm.formFields.horaHasta.id
                                          ),
                                          id: _vm.formFields.horaHasta.id,
                                          disabled: _vm.disabled
                                        },
                                        model: {
                                          value: _vm.formFields.horaHasta.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.horaHasta,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.horaHasta.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isVelocidadSitios,
                                          expression: "isVelocidadSitios"
                                        }
                                      ],
                                      attrs: { elevation: "0" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Mostrar Etiqueta" },
                                        model: {
                                          value: _vm.mostrarEtiqueta,
                                          callback: function($$v) {
                                            _vm.mostrarEtiqueta = $$v
                                          },
                                          expression: "mostrarEtiqueta"
                                        }
                                      }),
                                      _c("v-checkbox", {
                                        attrs: { label: "Modificar Semáforo" },
                                        model: {
                                          value: _vm.semaforo,
                                          callback: function($$v) {
                                            _vm.semaforo = $$v
                                          },
                                          expression: "semaforo"
                                        }
                                      }),
                                      _c(
                                        "v-card",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.semaforo,
                                              expression: "semaforo"
                                            }
                                          ],
                                          attrs: { elevation: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "divClassLabel"
                                                },
                                                [_vm._v("Verde <=")]
                                              ),
                                              _c("v-text-field", {
                                                staticClass: "shrink",
                                                attrs: {
                                                  type: "number",
                                                  min: "0",
                                                  label: "Verde"
                                                },
                                                model: {
                                                  value: _vm.verde,
                                                  callback: function($$v) {
                                                    _vm.verde = _vm._n($$v)
                                                  },
                                                  expression: "verde"
                                                }
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "divClassLabel"
                                                },
                                                [_vm._v("> Amarillo <=")]
                                              ),
                                              _c("v-text-field", {
                                                staticClass: "shrink",
                                                attrs: {
                                                  type: "number",
                                                  min: "0",
                                                  label: "Amarillo"
                                                },
                                                model: {
                                                  value: _vm.amarillo,
                                                  callback: function($$v) {
                                                    _vm.amarillo = _vm._n($$v)
                                                  },
                                                  expression: "amarillo"
                                                }
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "divClassLabel"
                                                },
                                                [_vm._v("> Rojo <=")]
                                              ),
                                              _c("v-text-field", {
                                                staticClass: "shrink",
                                                attrs: {
                                                  type: "number",
                                                  min: "0",
                                                  label: "Rojo"
                                                },
                                                model: {
                                                  value: _vm.rojo,
                                                  callback: function($$v) {
                                                    _vm.rojo = _vm._n($$v)
                                                  },
                                                  expression: "rojo"
                                                }
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "divClassLabel"
                                                },
                                                [_vm._v("> Rojo Oscuro")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isDetencion,
                                          expression: "isDetencion"
                                        }
                                      ],
                                      attrs: { elevation: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "padding-left": "5px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Tiempo de detención mínimo\n                  "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "text-detencion",
                                            attrs: { label: "Días" },
                                            model: {
                                              value: _vm.detentionDays,
                                              callback: function($$v) {
                                                _vm.detentionDays = $$v
                                              },
                                              expression: "detentionDays"
                                            }
                                          }),
                                          _c("v-text-field", {
                                            staticClass: "text-detencion",
                                            attrs: { label: "Horas" },
                                            model: {
                                              value: _vm.detentionHours,
                                              callback: function($$v) {
                                                _vm.detentionHours = $$v
                                              },
                                              expression: "detentionHours"
                                            }
                                          }),
                                          _c("v-text-field", {
                                            staticClass: "text-detencion",
                                            attrs: { label: "Minutos" },
                                            model: {
                                              value: _vm.detentionMinutes,
                                              callback: function($$v) {
                                                _vm.detentionMinutes = $$v
                                              },
                                              expression: "detentionMinutes"
                                            }
                                          }),
                                          _c("v-checkbox", {
                                            attrs: { label: "Mostrar Sitio" },
                                            model: {
                                              value: _vm.mostrarSitio,
                                              callback: function($$v) {
                                                _vm.mostrarSitio = $$v
                                              },
                                              expression: "mostrarSitio"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("CheckConsolidadoProveedor", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isConsolidadoProveedor,
                                    expression: "isConsolidadoProveedor"
                                  }
                                ]
                              }),
                              _c(
                                "v-flex",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isHorometro,
                                      expression: "isHorometro"
                                    }
                                  ],
                                  attrs: { elevation: "0" }
                                },
                                [
                                  _c("v-checkbox", {
                                    attrs: { label: "Mostrar Solo Actual" },
                                    model: {
                                      value: _vm.mostrarAcumulado,
                                      callback: function($$v) {
                                        _vm.mostrarAcumulado = $$v
                                      },
                                      expression: "mostrarAcumulado"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("CheckActividad", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isActividad,
                                    expression: "isActividad"
                                  }
                                ]
                              }),
                              _c(
                                "v-flex",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isDetalleViaje,
                                      expression: "isDetalleViaje"
                                    }
                                  ],
                                  attrs: { elevation: "0" }
                                },
                                [
                                  _c("v-checkbox", {
                                    attrs: { label: "Mostrar Etiqueta" },
                                    model: {
                                      value: _vm.mostrarEtiqueta,
                                      callback: function($$v) {
                                        _vm.mostrarEtiqueta = $$v
                                      },
                                      expression: "mostrarEtiqueta"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("CheckDetalleViaje", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isDetalleViaje,
                                    expression: "isDetalleViaje"
                                  }
                                ]
                              }),
                              _c("CheckSitio", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSitio || _vm.isZonaMinTran,
                                    expression: "isSitio || isZonaMinTran"
                                  }
                                ]
                              }),
                              _c("CheckResumenTiempos", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isResumenTiempos,
                                    expression: "isResumenTiempos"
                                  }
                                ]
                              }),
                              _c("CheckExcesoVelodicad", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isExcesoVelocidad,
                                    expression: "isExcesoVelocidad"
                                  }
                                ]
                              }),
                              _c("CheckTemperatura", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isTemperatura,
                                    expression: "isTemperatura"
                                  }
                                ]
                              }),
                              _c("PantallaAlertas", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isAlerta,
                                    expression: "isAlerta"
                                  }
                                ]
                              }),
                              _c(
                                "FormFieldsContainer",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.primeraTabla,
                                      expression: "primeraTabla"
                                    }
                                  ],
                                  attrs: { column: "" }
                                },
                                [_c("v-divider")],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c("containerPlanMantenimiento", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isContainerMantenimiento,
                            expression: "isContainerMantenimiento"
                          }
                        ]
                      }),
                      _c("br", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isContainerMantenimiento,
                            expression: "isContainerMantenimiento"
                          }
                        ]
                      }),
                      _c("containerInformeDescargas", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isDescargas,
                            expression: "isDescargas"
                          }
                        ]
                      }),
                      _c(
                        "v-card",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.report_type,
                              expression: "report_type"
                            }
                          ],
                          staticClass: "rounded-card mt-20"
                        },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("AsociarFlotaEtiquetaVehiculo", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.isContainerMantenimiento &&
                                      !_vm.isDescargas &&
                                      !_vm.isGeotec,
                                    expression:
                                      "\n                  !isContainerMantenimiento && !isDescargas && !isGeotec\n                "
                                  }
                                ],
                                attrs: {
                                  colDefVehiculo: _vm.colDefVehiculo,
                                  esInforme: true,
                                  reportType: _vm.report_type
                                },
                                on: { change: _vm.handleVehiculosChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-card",
                        { staticClass: "rounded-card mt-20" },
                        [
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isContainerMantenimiento,
                                  expression: "isContainerMantenimiento"
                                }
                              ]
                            },
                            [
                              _c("AsociarFlotaEtiquetaVehiculoXMantenimiento", {
                                on: { change: _vm.handleAsociacionesChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c(
                        "v-card",
                        { staticClass: "rounded-card mt-20" },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "FormFieldsContainer",
                                { attrs: { titulo: "Descargar Informe" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.row,
                                        callback: function($$v) {
                                          _vm.row = $$v
                                        },
                                        expression: "row"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.isGeotec &&
                                              !_vm.isZonaMinTran,
                                            expression:
                                              "!isGeotec && !isZonaMinTran"
                                          }
                                        ],
                                        attrs: { label: "EXCEL", value: "xlsx" }
                                      }),
                                      _c("v-radio", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.isGeotec,
                                            expression: "!isGeotec"
                                          }
                                        ],
                                        attrs: { label: "CSV", value: "csv" }
                                      }),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-crear",
                                          on: {
                                            click: function($event) {
                                              return _vm.handleClick()
                                            }
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("Generar Informe")
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.row == "pdf",
                                      expression: "row == 'pdf'"
                                    }
                                  ],
                                  attrs: { align: "left" }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md2: "" } },
                                    [
                                      _c("v-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value:
                                              this.row == "pdf"
                                                ? "required"
                                                : "",
                                            expression:
                                              "this.row == 'pdf' ? 'required' : ''"
                                          }
                                        ],
                                        attrs: {
                                          items: _vm.itemsOrientacion,
                                          label: "Orientación",
                                          icon: "fas fa-angle-down",
                                          "item-text": "descripcion",
                                          "item-value": "id",
                                          "error-messages": _vm.errors.collect(
                                            "orientacion"
                                          ),
                                          "data-vv-name": "orientacion"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.orientacionPdf.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.orientacionPdf,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.orientacionPdf.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("app-confirmacion", {
            attrs: {
              show: _vm.dialogConfirmacionClose,
              titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
              mensaje: _vm.$t("mensajes.mensajesInformes.mensaje"),
              textoBtnSi: _vm.$t("mensajes.mensajesInformes.btnAceptar"),
              textoBtnNo: _vm.$t("mensajes.mensajesInformes.btnCancelar")
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.confirmCallbackConfirm($event, false)
              }
            }
          }),
          _c("MensajeValidacion", {
            attrs: {
              showDialog: _vm.showValidacionReporteRestricciones,
              titulo: _vm.$t(_vm.tituloValidacion),
              mensaje: _vm.$t(_vm.mensajeValidacion),
              href: _vm.$t(_vm.mensajeHRef),
              mensajeBot: _vm.$t(_vm.mensajeValidacionBot)
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.confirmReporteTime($event)
              }
            }
          }),
          _c("app-confirmacion", {
            attrs: {
              show: _vm.showValidacionReporteTime,
              titulo: _vm.$t(_vm.tituloValidacion),
              mensaje: _vm.$t(_vm.mensajeValidacion),
              textoBtnSi: _vm.$t("mensajes.mensajesInformes.btnAceptar"),
              textoBtnNo: _vm.$t(
                "mensajes.mensajesInformes.btnCancelarGeneracion"
              )
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.confirmReporteTime($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }